// sectionConfig.js
// The generic table renderers this config once drove (renderSection/ListContent)
// were removed in the AI2-546 redesign — TenderAnalysisResults.jsx owns section
// rendering now. result.js still uses sectionOrder to count completed sections
// for the streaming progress bar.

export const SECTION_CONFIG = {
  sectionOrder: [
    'executive_summary',
    'price_analysis',
    'programme_analysis',
    'inclusions_exclusions',
    'risks',
    'opportunities',
    'clarifications_required',
    'scope_analysis',
  ],
};
